import React from 'react';

import { Box, Typography } from '@mui/material';
import FixedContainer from '../../components/Container';
import { useAuth } from '../../hooks/auth';

import logoImg from "../../images/signinImg.svg";

const Wellcome = ({ history }) => {

  const { user } = useAuth();

  return (
    <>
      <FixedContainer>
        <Box sx={{
          width: '100%',
          height: '100%',
          backgroundColor: '#F9FBFD',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          boxShadow: 3,
          borderRadius: '10px',
          padding: 2,
        }}>
          <Box sx={{display: 'flex', width: '100%'}}>
            <Box sx={{
              display: 'flex',
              width: '100%',
              height: '75vh',
              paddingLeft: '5%',
            }}>
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                width: '650px',
                height: '70vh',
                zIndex: 5
              }}>
                <Typography
                  variant='h1'
                  sx={{
                    fontSize: '65px',
                    fontWeight: 400,
                  }}
                >
                  Bem-vindo(a), {user.username}!
                </Typography>

                <Typography
                  variant='p'
                  sx={{
                    fontSize: '30px',
                    marginTop: 5
                  }}
                  >
                  Para navegar nas funcionalidades da página, selecione uma das opções do menu lateral.
                </Typography>
              </Box>
              <Box
                component="img"
                sx={{
                  position: 'absolute',
                  right: '5%',
                  bottom: '10%',
                  maxHeight: '80%',
                }}
                alt="Error"
                src={logoImg}
              />
            </Box>
          </Box>
        </Box>
      </FixedContainer>
    </>
  );
}

export default Wellcome;